import { Component, OnInit, Input } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular';
import { ApiserviceService } from 'src/app/httpservice/apiservice.service';
import { errDelMsg, sccDelMsg } from '../delete-seller-modal/deleteseller.const';
@Component({
  selector: 'app-delete-seller-modal',
  templateUrl: './delete-seller-modal.component.html',
  styleUrls: ['./delete-seller-modal.component.scss'],
})
export class DeleteSellerModalComponent implements OnInit {

  @Input() sellerId;
  @Input() sellerName;
  @Input() taxId;

  constructor(public modalCtrl: ModalController, private apiService: ApiserviceService, 
    private loadingController: LoadingController, private alertController: AlertController) { }

  ngOnInit() { }
  
  validateResponse(response) {
    if(typeof response !== 'object') {
      return false;
    }
    if(!response.hasOwnProperty('statusMessage')) {
      return false;
    }
    if(response.statusCode !== 200) {
      return false;
    }
    return  true;
  }
  cancelModal() {
    this.modalCtrl.dismiss({
      confirm: false,
    });
  }

  async confirmModal() {
    const reqBody = {
      deleteSellerData: {
        id: this.sellerId
      }
    }
    const response = await this.apiService._post(this.apiService.apiUrl + this.apiService.editSeller, reqBody);
    const valid = this.validateResponse(response);
    try {
      if(!valid) {
        this.modalAlert(errDelMsg.errDel);
      } else {
        this.modalAlert(sccDelMsg.sccDel);
        this.modalCtrl.dismiss({
          sellerId : this.sellerId,
          confirm: true,
        });
      }
    } catch(e) {

    }
  }

  async modalAlert(altMsg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: altMsg
    });
    await alert.present();
    setTimeout(() => {
      alert.dismiss(true);
    }, 2000);
  }
}
